import { useRef, useState } from "react";
import avatar_men from "../assets/img/men-teacher.png";
import avatar_girl from "../assets/img/girl-teacher.png";
import moment from "moment";
import ViewUserInfo from "../component/ViewUserInfo";
const formatDate = (timestamp) => moment(new Date(timestamp * 1000)).format("HH:mm DD/MM/YYYY");

const PostHeader = ({ data }) => {
    const [showInfo, setShowInfo] = useState(false);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        timeoutRef.current = setTimeout(() => setShowInfo(true), 300);
    };
    const handleMouseLeave = () => {
        clearTimeout(timeoutRef.current);
        setShowInfo(false);
    };

    return (
        <div className="post-header cursor-pointer position-relative d-flex" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <img className="avatar shadow-sm" src={data.avatar ? `${data.avatar}&size=avatar` : data.sex === "Nam" ? avatar_men : avatar_girl} alt="" />
            <div className="u-details pl-2">
                <strong className="w-100 d-inline-block author">
                    {data.fullname} | {data.part_name} | {data.vanthu_code}
                </strong>
                <div className="w-100 d-flex align-items-center">
                    <p className="mb-0 date">{formatDate(data.datecreate)}</p>
                    {data.group_name && data.group_id ? <p className="mb-0 text-success ml-2"><span className="fas fa-angle-double-right"></span> <strong>#{data.group_name}</strong></p> : ''}
                </div>
            </div>
            {showInfo && <ViewUserInfo user_id={data.user_id} />}

        </div>
    );
};
export default PostHeader;